// extracted by mini-css-extract-plugin
export default {"root":"DeletionPolicy_root__Rp6md"};